import "./zone-flags";
import "zone.js";

// Some 3rd-party libs check for `global` which is not there.
// See https://github.com/angular/angular-cli/issues/9827#issuecomment-386154063
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any)["global"] = window;
